/**
 * @generated SignedSource<<56f4baafca333faf75f7d54926973a2c>>
 * @relayHash 3010f6b1356aae10019a1ad07e146372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 799d904d34743a2ad3869f0c1587983f184044efc037e58ca7920c9641500955

import type { ConcreteRequest } from 'relay-runtime';
export type useUpdateContentPropertyPageUpdateMutation$variables = {
  pageId: string;
  propertyKey: string;
  propertyValue: string;
};
export type useUpdateContentPropertyPageUpdateMutation$data = {
  readonly confluence: {
    readonly updateValuePageProperty: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null;
        } | null;
        readonly message: string | null;
      }> | null;
      readonly pageProperty: {
        readonly id: string | null;
        readonly key: string;
        readonly value: string;
      } | null;
      readonly success: boolean;
    } | null;
  } | null;
};
export type useUpdateContentPropertyPageUpdateMutation = {
  response: useUpdateContentPropertyPageUpdateMutation$data;
  variables: useUpdateContentPropertyPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyValue"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "propertyKey"
      },
      {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "propertyValue"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "success"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "concreteType": "ConfluencePageProperty",
  "kind": "LinkedField",
  "name": "pageProperty",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "message"
},
v8 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateContentPropertyPageUpdateMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "ConfluenceUpdateValuePagePropertyPayload",
            "kind": "LinkedField",
            "name": "updateValuePageProperty",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateContentPropertyPageUpdateMutation",
    "selections": [
      {
        "concreteType": "ConfluenceMutationApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "ConfluenceUpdateValuePagePropertyPayload",
            "kind": "LinkedField",
            "name": "updateValuePageProperty",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3010f6b1356aae10019a1ad07e146372",
    "id": "799d904d34743a2ad3869f0c1587983f184044efc037e58ca7920c9641500955",
    "metadata": {},
    "name": "useUpdateContentPropertyPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentPropertyPageUpdateMutation($propertyKey:String!,$pageId:ID!,$propertyValue:String!){confluence{updateValuePageProperty(input:{key:$propertyKey,pageId:$pageId,value:$propertyValue}){success,pageProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
  }
};
})();

(node as any).hash = "4b090e3281dd15c3d9500ac77008df26";

export default node;
